import { Link } from "@reach/router"

export function Footer({
  directoryFieldData,
  disabled,
  isCurrentlyInDirectory,
  onClick,
}) {
  if (isCurrentlyInDirectory) {
    return (
      <div className="d-f jc-sb my-2">
        <button
          className="btn secondary-btn destroy-btn"
          type="submit"
          disabled={disabled}
          onClick={() => onClick([])}
        >
          Remove all
        </button>
        <button
          className="btn secondary-btn"
          type="submit"
          disabled={disabled}
          onClick={() => onClick(directoryFieldData)}
        >
          Update profile
        </button>
      </div>
    )
  } else {
    return (
      <div className="d-f fd-c ai-c my-3">
        <button
          className="btn mb-2"
          type="submit"
          disabled={disabled}
          onClick={() => onClick(directoryFieldData)}
        >
          Join directory
        </button>
        <Link to="/directory" className="c-tint3 text-btn">
          Ask me later
        </Link>
      </div>
    )
  }
}
